let ViewAndFilterHelpers = {
  filterFromId: (filterObjects, id) => (filterObjects.find((fo) => (fo.id === id))),
  viewFromId: (viewObjects, id) => (viewObjects.find((vo) => vo.id === id))
};

export default ViewAndFilterHelpers;
